import { Box, List, ListItemText } from '@mui/material';
import { Can } from 'core/components/permissions/Can';
import { ModuleGuard } from 'core/components/modules';
import { isNil } from 'lodash';
import { observer } from 'mobx-react-lite';
import { NavLink as RouterLink } from 'react-router-dom';
import { StyledNavItem, StyledNavItemIcon } from './styles';
import type { BoxProps } from '@mui/material';
import type { NavConfigItem } from 'config/navConfig';
import type { FC, ReactElement } from 'react';

function NavItem({ item }: { key: string; item: NavConfigItem }): JSX.Element {
  const { title, path, icon, info } = item;

  return (
    <li>
      <StyledNavItem
        component={RouterLink}
        to={path}
        sx={{
          '&.active': {
            color: 'text.primary',
            bgcolor: 'action.selected',
            fontWeight: 'fontWeightBold',
          },
        }}>
        <StyledNavItemIcon>{!isNil(icon) && icon}</StyledNavItemIcon>
        <ListItemText disableTypography primary={title} />
        {!isNil(info) && info}
      </StyledNavItem>
    </li>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const NavSection: FC<BoxProps<any> & { data: NavConfigItem[] }> = observer(
  ({ data = [], ...other }) => {
    const getNavItem = (item: NavConfigItem): ReactElement => (
      <NavItem key={item.title} item={item} />
    );

    const getNavItemWithChecks = (item: NavConfigItem): ReactElement => {
      let navItem = getNavItem(item);

      // Проверка прав доступа
      if (!isNil(item.permission)) {
        navItem = (
          <Can key={item.title} I='read' a={item.permission}>
            {navItem}
          </Can>
        );
      }

      // Проверка доступности модуля
      if (!isNil(item.module)) {
        navItem = (
          <ModuleGuard key={item.title} module={item.module}>
            {navItem}
          </ModuleGuard>
        );
      }

      return navItem;
    };

    return (
      <Box {...other}>
        <List disablePadding sx={{ p: 1 }}>
          {data.map((item) => getNavItemWithChecks(item))}
        </List>
      </Box>
    );
  }
);
export default NavSection;
